import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

// Eingefrorene Demo-Gegenwart: mit gesetztem VITE_DEMO_NOW liefert nowUtc()
// ein fixes "Jetzt" (Demo-Stack), sonst die echte Zeit. Nur für
// Daten-Vergleiche gedacht — nie für Auth/Token-Logik.
const demoNowMs = (() => {
  const raw = import.meta.env.VITE_DEMO_NOW
  if (!raw) return null
  const ms = dayjs.utc(raw).valueOf()
  return Number.isFinite(ms) ? ms : null
})()

export function nowUtc() {
  return demoNowMs != null ? dayjs.utc(demoNowMs) : dayjs.utc()
}

export function nowMs() {
  return demoNowMs ?? Date.now()
}

// Einzige Definition von "läuft als Demo" — z.B. für den Reset beim Logout.
export const isDemoMode = demoNowMs != null
